<template>
<div class="">
  <form
    @submit.prevent="submit">
    <v-card class="px-1 rounded-lg elevation-2">
      <div v-if="title" class="ml-5 pt-5 mb-3 font-weight-bold">
        {{ title }}
      </div>
      <v-card-text class="px-5">
        <div v-for="(item, index) in items" :key="index">
          <v-textarea
            v-if="item.inputType === 'textarea'"
            v-model="$v.form[item.name].$model"
            :label="item.inputLabel"
            required
            outlined
            dense />
          <v-checkbox
            v-else-if="item.inputType === 'checkbox'"
            v-model="$v.form[item.name].$model"
            :label="item.inputLabel"
            required
            outlined
            dense />
          <v-select
            v-else-if="item.inputType === 'picklist'"
            :label="item.inputLabel"
            @change="onChange($event, item)"
            v-model="$v.form[item.name].$model"
            item-text="text"
            item-value="value"
            :items="getOptions(item.options)"
            required
            outlined
            :chips="item.multiple"
            small-chips
            :multiple="item.multiple"
            class="select-chips"
            dense />
          <v-select
            v-else-if="item.inputType === 'year'"
            v-model="$v.form[item.name].$model"
            :label="item.inputLabel"
            @change="onChange($event, item)"
            item-text="text"
            item-value="value"
            :items="getYears(item.startYear)"
            required
            outlined
            dense />
          <v-date-picker
            v-else-if="item.inputType==='large-date'"
            v-model="$v.form[item.name].$model"
            :label="item.inputLabel"
            required
            outlined
            dense />
          <div
            v-else-if="item.inputType==='divider'"
            class="hr-sect">
            {{ item.inputLabel }}
          </div>
          <v-file-input
            v-else-if="item.inputType === 'file'"
            :label="item.inputLabel"
            v-model="$v.form[item.name].$model"
            :loading="!!loadingFields[item.name]"
            show-size
            counter
            truncate-length="15"
            @change="loadFile(item)" />
          <v-text-field
            v-else
            :rules="getRules(item.inputType)"
            :type="item.inputType"
            v-model="$v.form[item.name].$model"
            :label="item.inputLabel"
            required
            outlined
            dense />
        </div>
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          class="font-weight-bold"
          :class="{'black--text': branding.primaryButtons.darkText}"
          :disabled="continueDisabled"
          v-bind="branding.primaryButtons">
          Continue
          <v-icon size="22" class="ml-2 mt-1">
              mdi-arrow-right-circle
            </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate';

import {
  required,
} from 'vuelidate/lib/validators';

import {
  mapActions,
} from 'redux-vuex';

import {
  postFile,
} from '../endpoints';

export default {
  name: 'InputMultiForm',
  mixins: [validationMixin],
  props: {
    error: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => 'Enter your details',
    },
    items: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: () => 'Please enter the code provided',
    },
    instanceKey: {
      type: String,
      default: () => '',
    },
    reason: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    continueDisabled() {
      return Object.values(this.loadingFields).some((el) => !!el);
    },
    // valueErrors() {
    //   const errors = [];
    //   if (!this.$v.form.value.$dirty) return errors;
    //   if (this.$v.form.value.$error) {
    //     errors.push('Please provide a value');
    //   }
    //   return errors;
    // },
  },
  data() {
    return {
      ...this.mapState('branding'),
      form: this.generateModel(),
      emailRules: [
        (value) => {
          if (value) return true;
          return 'Field cannot be empty';
        },
        (value) => {
          if (/.+@.+\..+/.test(value)) return true;
          return 'E-mail must be valid.';
        },
      ],
      phoneRules: [
        (value) => {
          if (value) return true;
          return 'Field cannot be empty';
        },
        (value) => {
          if (/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(value)) return true;
          return 'Phone number must be valid.';
        },
      ],
      required: [
        (value) => {
          if (value) return true;
          return 'Field cannot be empty';
        },
      ],
      loadingFields: {},
    };
  },
  validations() {
    return {
      form: this.generateValidations(),
    };
  },
  methods: {
    ...mapActions(
      'callApi',
    ),
    getOptions(options) {
      return options.map((o) => ({
        text: o,
        value: o,
      }));
    },
    getRules(type) {
      switch (type) {
        case 'email':
          return this.emailRules;
        case 'phone':
          return this.phoneRules;
        default:
          return this.required;
      }
    },
    getYears(year) {
      const startYear = parseInt(year, 10);
      const currentYear = new Date().getFullYear();
      const interval = currentYear - startYear + 1;
      const years = [...Array(interval).keys()].map((i) => ({
        text: currentYear - i,
        value: currentYear - i,
      }));
      return years;
    },
    onChange(e, f) {
      console.log(e);
      this.$set(this.form, f.key, {
        text: f.key,
        value: e,
      });
    },
    generateModel() {
      return this.items.reduce((acc, cv) => {
        acc[cv.name] = '';

        return acc;
      }, {});
    },
    generateValidations() {
      return this.items.reduce((acc, cv) => {
        acc[cv.name] = {};
        if (cv.validations && cv.validations.required) {
          acc[cv.name].required = { required };
        }
        return acc;
      }, {});
    },
    async loadFile(item) {
      if (!(item.name in this.loadingFields)) this.loadingFields[item.name] = 0;
      this.loadingFields[item.name] += 1;

      const file = this.$v.form[item.name].$model;

      const formData = new FormData();
      Object.entries(item.fields).forEach(([key, val]) => formData.append(key, val));
      formData.append('file', file);

      await this.callApi(postFile(
        item.url,
        formData,
      ));

      this.$v.form[item.name].$model = {
        size: file.size,
        type: file.type,
        name: file.name,
      };

      this.loadingFields[item.name] -= 1;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit('error', 'invalid');
        return;
      }

      this.$emit('trigger', {
        form: this.form,
        instanceKey: this.instanceKey,
        reason: this.reason,
      });
      this.$emit('error', null);
      this.$emit('close-dialog');
    },
  },
};
</script>
<style lang="scss">
.hr-sect {
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: rgba(0, 0, 0, 0.35);
    margin: 8px 0;

    &:before, &:after {
        content: "";
        flex-grow: 1;
        background: rgba(0, 0, 0, 0.35);
        height: 1px;
        font-size: 0;
        line-height: 0;
        margin: 0 8px;
    }
}
.select-chips {
  .v-chip--select {
    margin-top: 6px !important;
  }
}
</style>
